import { useState } from "react";

import { Image } from "./icons_new";

const ProductImageCell = ({ imageUrl, alt }) => {
  const [isLoaded, setIsLoaded] = useState(false);
  // TODO: Replace this part with an icon instead of an image
  const defaultImage = "/images/default-img.jpg";

  return (
    <div className="relative w-10 h-10">
      {!isLoaded && (
        <div className="absolute inset-0 bg-gray-200 animate-pulse rounded-md" />
      )}
      <img
        src={imageUrl ?? defaultImage}
        alt={alt ?? "Product Image"}
        className={`w-full h-full object-cover rounded-md ${isLoaded ? "block" : "hidden"}`}
        onLoad={() => setIsLoaded(true)}
        onError={(e) => {
          e.currentTarget.onerror = null;
          e.currentTarget.src = defaultImage;
        }}
      />
    </div>
  );
};

export default ProductImageCell;